import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";
import { ReactComponent as SelectIcon } from "@common/images/SelectIcon.svg";
import { SchoolLevelSubjects } from "@common/SchoolLevelSubjects";
import { useStores } from "@hooks/useStores";
import i18next from "@lang/index";
import { IProject } from "@repositories/model/IProject";
import { ProjectSchoolType } from "@stores/enums/ProjectStoreEnums";
import useEmotionStyles from "@styles/shared/useEmotionStyles";
import { TableHomeTaskStlye } from "@styles/layout/TableHomeTaskStlye";
import { observer } from "mobx-react";

type Props = {
	subjectName: string,
	subjectIndex: number,
	subjectNameIndex: number,
	schoolTypeId: ProjectSchoolType,
	project: IProject,
	onSubjectNameChange: (subjectName: string) => void,
}

function SubjectNameMenuItem(props: Props) {
	const classes = useEmotionStyles(TableHomeTaskStlye);
	const { subjectName, schoolTypeId, subjectIndex, subjectNameIndex, onSubjectNameChange } = props;
	const { navigateStore, projectStore } = useStores();

	const schoolTypeIndex = SchoolLevelSubjects.findIndex(
		(subject) => {
			const isSame = subject.id === schoolTypeId;
			return isSame;
		}
	);

	const renderSubjectMenuItems = (): JSX.Element[] => {
		if (schoolTypeIndex < 0) {
			console.warn("No valid school type index");
			return [
				<MenuItem key={"ItemNone"} disabled>
					{i18next.t("과목 없음")}
				</MenuItem>,
			];
		}
	
		const subjectGroup = SchoolLevelSubjects[schoolTypeIndex].subjectGroups;
	
		console.log("Rendering subjects for:", subjectGroup);
	
		return subjectGroup.map((subject) => {
			return (
				<MenuItem key={subject.name} value={subject.name}>
					{i18next.t(subject.text)}
				</MenuItem>
			);
		});
	};
	
	const getSubjectSelectValue = (): string | number => {
		if (subjectName) {
			console.log("✅ Using subjectName:", subjectName);
			return subjectName;
		}
	
		console.log("⚠️ No subjectName found, defaulting to 0");
		return 0;
	};
	
	


	const handleChangeSubjectName = (e) => {
		const subjectName = e.target.value;

		onSubjectNameChange(subjectName);		
	}


	return (
		<FormControl className={classes.formControl}>
			<Select
				IconComponent={(props) => (
					<Box>
						<SelectIcon  {...props} />
					</Box>
				)}
				MenuProps={{
					anchorOrigin: {
						vertical: "bottom",
						horizontal: "right"
					},
					transformOrigin: {
						vertical: 'top',
						horizontal: 'right',
					},
					// getContentAnchorEl: null,
					className: classes.selectPopover
				}}
				displayEmpty
				onChange={handleChangeSubjectName}
				value={getSubjectSelectValue()}
			>
				<MenuItem value={0}>
					<Typography>{i18next.t("과목 선택")}</Typography>
				</MenuItem>

				{
					renderSubjectMenuItems()
				}
			</Select>
		</FormControl>
	)

}

export default observer<typeof SubjectNameMenuItem>(SubjectNameMenuItem);
